// Following the same approach Tom took for the Events editor, this is
// a temporary workaround for the fact that GTL depends on react-native
// in order to determine if it should use react-native.

export const Platform = {
  OS: "web",
};
export const NativeModules = {
  RNWTelemetryProvider: {},
};
